export default __webpack_public_path__ + "02aecb74c95e5394c140f50af6552e45.png";